import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Typography, Link, Box, Stack} from 'views/components';

const NavbarLogo = () => {
  return (
    <Stack
      direction={'row'}
      spacing={1}
      alignItems={'center'}
    >
      <Box
        component="img"
        src="/logo/quilt-icon.png"
        alt="Quilt Icon"
        sx={{
          width: '24px', // adjust as needed
          height: '24px', // maintains aspect ratio
        }}
      />
      <Link
        href='/'
        underline='none'
      >
        <Typography
          sx={{
            'color': 'white',
            'fontWeight': 500,
            'fontSize': '24px',
            'display': 'inline-block',
          }}
        >
          Quilt
        </Typography>
      </Link>
    </Stack>
  );
};

NavbarLogo.propTypes = {
};
const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NavbarLogo));
